import { AttachmentUpload } from "./attachment_upload";
addEventListener("trix-attachment-add", event => {
  const attachment = event.attachment,
    target = event.target;
  if (attachment.file) {
    const upload = new AttachmentUpload(attachment, target);
    upload.start();
  }
});